import { createElement, render, RenderPosition } from '../../../../js/utils/render'
import Form from '../../../../js/Form/Form'

const gradeOfType = {
  course: 'Basic',
  profession: 'Advanced'
}

const getHeaderTemplate = ({ title, description }) => (
  `<div class="up-sale-form__top ui-typography-group">
    <h3 class="up-sale-form__title h h--5">
      ${title}
    </h3>

    ${description
    ? `<p class="up-sale-form__desc p p--2">
          ${description}
        </p>`
    : ''
  }
  </div>`
)

export class UpSaleForm {
  data = {
    pay: {
      title: 'Выберите формат обучения'
    },
    consult: {
      title: 'Выберите формат обучения',
      description: 'Или дождитесь звонка менеджера&nbsp;&mdash; он&nbsp;поможет определиться'
    }
  }

  constructor(wrapper, template, { type, blockName }) {
    this.wrapper = wrapper
    this.template = template
    this.headerTmplate = null
    this.type = type
    this.blockName = blockName
    this.form = template.querySelector('.form')
    this.typeHiddenField = template.querySelector('input[name=type]')
    this.titleHiddenField = template.querySelector('input[name=tariff_title]')
    this.previousCheckedInput = null
  }

  render() {
    this.renderHeaderElement()
    this.formInit()
  }

  destroy() {
    this.form.removeEventListener('form-sended', this.formSubmitHandler)
    this.form.removeEventListener('click', this.inputClickHandler)

    this.removeHeaderElement()
    this.template.remove()
  }

  formInit() {
    this.form.addEventListener('form-sended', this.formSubmitHandler)
    this.form.addEventListener('click', this.inputClickHandler)

    new Form({
      form: this.form,
      blockName: 'UpSale Form'
    }).init()

    render(this.wrapper, this.template)
  }

  emitFormEvent(form, params, name) {
    const customEvent = new Event(name)

    customEvent.sendingResult = params
    form.dispatchEvent(customEvent)
  }

  formSubmitHandler = (evt) => {
    evt.preventDefault()

    const checkedField = this.form.querySelector('.up-sale-type__input:checked')
    const upSaleType = checkedField?.dataset.type

    window.$analytics?.push('up-sale-click', {
      label: `${this.blockName}|${gradeOfType[upSaleType]}`,
      type: upSaleType
    })
  }

  inputClickHandler = (evt) => {
    if (!evt.target.classList.contains('up-sale-type__input')) {
      return
    }

    if (evt.target === this.previousCheckedInput && evt.target.checked) {
      evt.target.checked = false
      this.previousCheckedInput = null
      this.form.classList.remove('has-selection')
      return
    }

    this.previousCheckedInput = evt.target.checked ? evt.target : null

    const checkedField = this.form.querySelector('.up-sale-type__input:checked')

    this.typeHiddenField.value = gradeOfType[checkedField?.dataset.type].toLowerCase() === 'basic' ? 'no-upsale' : 'upsale'
    this.titleHiddenField.value = checkedField?.dataset.title

    if (checkedField) {
      this.form.classList.add('has-selection')

      this.emitFormEvent(this.form, { checkedField }, 'input-click')
    }
  }

  renderHeaderElement() {
    this.headerTmplate = createElement(getHeaderTemplate(this.data[this.type]))
    render(this.template, this.headerTmplate, RenderPosition.AFTERBEGIN)
  }

  removeHeaderElement() {
    if (this.headerTmplate === null) {
      return
    }

    this.headerTmplate.remove()
    this.headerTmplate = null
  }
}
